import "./games.css"; // 创建一个专门的样式文件
import Header from "../components/common/Header";

const GamesPage = () => {
  return (
    <div className="games-page">
      <Header />

      <section className="games-hero">
        <div className="container">
          <h1>Discover Wordle-inspired word games for all skill levels.</h1>
          <p>From simple puzzles to advanced challenges, there’s something for everyone. Play, challenge yourself, and improve your word skills!</p>
        </div>
      </section>

      <section className="games-list">
        <div className="container">
          <div className="games-grid">
            <div className="game-card">
              <h3>Dictadle</h3>
              <p>A Daily Dictation and Wordle-Inspired Listening Practice Game</p>
              <a href="/dictadle" className="btn btn-secondary">Play Now →</a>
            </div>
            <div className="game-card">
              <h3>Unlimited Spanish Wordle</h3>
              <p>Spanish Wordle Unlimited is a fun and engaging word puzzle game where players guess Spanish words within six attempts.</p>
              <a href="/spanish-wordle-unlimited" className="btn btn-secondary">Play Now →</a>
            </div>
            <div className="game-card">
              <h3>Wordle Unlimited</h3>
              <p>Play Wordle without limits! Solve as many puzzles as you like in a day.</p>
              <a href="/wordle-unlimited" className="btn btn-secondary">Play Now →</a>
            </div>   
          </div>
        </div>
      </section>

      <section className="games-cta">
        <div className="container">
          <h2>More Games Coming Soon!</h2>
          <p>We’re constantly adding new games and features. Stay tuned for updates.</p>
        </div>
      </section>
    </div>
  );
};

export default GamesPage;